<template>
  <div class="default-table customers-table">
    <v-tooltip left>
      <template v-slot:activator="{ on }">
        <v-btn
          v-if="permissions.customers.actions.new"
          v-on="on"
          @click.prevent="newDialog()"
          color="primary"
          class="mb-9"
          app
          fab
          bottom
          right
          fixed
        >
          <v-icon dark>mdi-plus</v-icon>
        </v-btn>
      </template>
      <span>{{ lang.customers.new.title }}</span>
    </v-tooltip>
    <customerView
      v-if="dialog.selected"
      :value="dialog.selected"
      :dialog="dialog.view"
      @edit="editDialog(dialog.selected)"
      @closed="onCloseView"
    />
    <customerSave
      v-if="dialog.selected"
      v-model="dialog.selected"
      :id="dialog.selected.id"
      :dialog="dialog.save"
      @closed="onCloseSave"
    />
    <DataTable
      name="customers"
      :items="items"
      :tablehdrs="tableheaders.customers"
      :search="true"
    >
      <template v-slot:toolbar="{}">
        <Birthdays
          :value="items"
        />
      </template>
      <template v-slot:default="{ item }">
        <tr
          :key="item.id"
          @dblclick="viewDialog(item)"
          class="table-row"
        >
          <td>
            <strong>{{ item.id }}</strong>
          </td>
          <td>
            {{ item.name }}
            
            <v-tooltip
              v-if="item.is_birthday"
              bottom
            >
              <template v-slot:activator="{ on }">
                <v-icon
                  v-on="on"
                  class="customer-birthday_icon"
                  small
                >
                  mdi-cake-variant
                </v-icon>
              </template>
              <span>{{ lang.customers.birthdays.today_birthday }}</span>
            </v-tooltip>
          </td>
          <td>
            {{ item.phone | phoneMask }}
          </td>
          <td>
            {{ item.identity | cpfMask }}
          </td>
          <td>
            {{ formatDateAlt(item.birth_date, false) }}
          </td>
          <td>
            <v-chip v-if="!item.addresses || item.addresses.length === 0" dark>{{ lang.customers.datatable.no_address }}</v-chip>
            <v-chip v-else v-for="(address, index) in item.addresses.slice().reverse().slice(0, 1)" :key="index" dark>{{ `${address.address} ${address.num} ${(address.comp !== undefined && address.comp ? '(' + address.comp + ')' : '' )} - ${address.neighborhood}` }}</v-chip>
          </td>
          <td class="actionsCol">
            <Actions :customer="item" @view="viewDialog(item)" @edit="editDialog(item)" />
          </td>
        </tr>
      </template>
      <template v-slot:mobile="{ item }">
        <tr
          :key="`mb-${item.id}`"
          @dblclick="viewDialog(item)"
          class="mobile_row table-row"
        >
          <td class="mobile_col">
            <ul class="flex-content pl-2">
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.id}:`">{{ item.id }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.name}:`">{{ item.name }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.phone}:`">{{ item.phone | phoneMask }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.identity}:`">{{ item.identity | cpfMask }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.birth_date}:`">{{ formatDateAlt(item.birth_date, false) }}</li>
              <li class="flex-item" :data-label="`${lang.customers.datatable.headers.address}:`">
                <v-chip v-if="!item.addresses || item.addresses.length === 0" dark>{{ lang.customers.datatable.no_address }}</v-chip>
                <div v-else v-for="(address_, indexA) in item.addresses.slice().reverse().slice(0, 1)" :key="indexA" class="defaultAddressView">
                  <p>{{ `${address_.address} ${address_.num} ${(address_.comp !== undefined && address_.comp ? '(' + address_.comp + ')' : '' )}` }}</p>
                  <p>{{ address_.neighborhood }}</p>
                  <p>{{ `${address_.city}/${address_.state} - ${address_.cep}` }}</p>
                </div>
              </li>
              <li class="flex-item actions_row" :data-label="lang.customers.datatable.headers.action">
                <Actions :customer="item" @view="viewDialog(item)" @edit="editDialog(item)" />
              </li>
            </ul>
          </td>
        </tr>
      </template>
    </DataTable>
  </div>
</template>

<script>
import DataTable from '@/templates/global/DataTable'
import Actions from './templates/Actions'
import Birthdays from './templates/birthdays/Birthdays'
import customerView from './View'
import customerSave from './Save'

import defaults from '@/modules/default'
import appdata from '@/mixins/appdata'
import utils from '@/mixins/utils'
import listDefaults from '@/mixins/defaults/list'

import moment from 'moment'

moment.locale('pt-br')

export default {
  components: { DataTable, Actions, Birthdays, customerView, customerSave },
  mixins: [ appdata, utils, listDefaults ],
  data: () => ({
    default: { ...defaults.blank.customer }
  }),
  computed: {
    items () {
      const data = [ ...this.get_data.customers ]
      data.map((obj) => {
        obj.phone_nomask = obj.phone
        obj.phone = this.phoneMask(obj.phone)
        obj.identity_nomask = obj.identity
        obj.identity = this.cpfMask(obj.identity)
        obj.is_birthday = this.isBirthday(obj.birth_date)
      })
      return data
    }
  },
  methods: {
    isBirthday (date) {
      if (typeof date !== 'undefined' && date !== null) {
        let birth_date = moment.utc(date).format('DD/MM'),
            today_date = moment().format('DD/MM')

        if (birth_date === today_date) {
          return true
        }
      }
      return false
    }
  }
}
</script>

<style scoped src="./styles/list.scss" lang="scss"></style>
